export const getAccessToken = () => {
  const token = sessionStorage.getItem("auth-token");
  return token;
};
